<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .form-control{
    border: none;
    background: #eee;
    font-size: 1.2em;
    color: #000;
  }

  textarea{
    resize: none;
  }
</style>

<style>
  .multiselect__tags,
  .multiselect__input,
  .multiselect__single {
    background: #f0f0f0;
    color: #000;
  }

  .multiselect__placeholder{
    color: #555;
  }
</style>
<template>
  <Loader v-if="fetchingPermissions" />

  <form v-else @submit="updateRolePermissions">
    <b-modal title="Manage Role Permissions"
      :visible="roleId !== null"
      @ok="close" @cancel="close" @hide="close">

      <!-- <p :class="{'text-muted': !createRoleError, 'text-danger': createRoleError}">
        {{ !createRoleError ? '' : 'Failed to create role' }}
      </p> -->

      <div v-if="roleBeingEdited" class="form-group mb-3">
        <label for="description">Role: </label>&nbsp;
        <strong class="d-block" style="font-weight: 500; margin-top: -0.35em;font-size: 20px">{{ roleBeingEdited.name }}</strong>
      </div>

      <div class="form-group mb-4">
        <label for="description">Permissions</label>

        <div v-if="!permissions">
          Error fethcing permissions
        </div>

        <div v-else-if="!permissions.length">
          No permissions found
        </div>

        <div v-else>
          <multiselect
            v-model="checkedPermissions"
            multiple
            required
            label="displayName"
            track-by="_id"
            :options="permissionOptions">
          </multiselect>

          <span v-if="formHasError && !checkedPermissions.length" class="hel-block text-danger">
            Add at least one permission
          </span>
        </div>
      </div>

      <template slot="modal-footer">
        <div class="row justify-content-end">
          <div class="px-3">
            <button @click="updateRolePermissions" :class="{disabled: creatingRole}" class="btn btn-primary px-4">
              {{ !creatingRole ? 'SAVE CHANGES' : 'Please Wait...' }}
            </button>
          </div>
        </div>
      </template>
    </b-modal>
  </form>
</template>

<script>
  import { mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';

  export default {
    name: 'ManagePermissions',
    props: {
      roleId: {
        type: String,
        required: true
      }
    },
    mounted(){
      if(!this.permissions)
        this.$store.dispatch('getPermissions');

      if(!this.roles){
        this.$store.dispatch('getRoles');
        this.$store.subscribe(mutation => {
          if(mutation.type === 'SET_ROLES')
            this.$store.dispatch('setRoleBeingEdited', this.roleId);
        });
      }
      else
        this.$store.dispatch('setRoleBeingEdited', this.roleId);
    },
    beforeDestroy(){
      this.$store.dispatch('setRoleBeingEdited', null);
    },
    data(){
      return {
        checkedPermissions: [],
        formHasError: false
      }
    },
    computed: {
      ...mapState(['fetchingPermissions', 'permissions', 'roleBeingEdited', 'creatingRole', 'createRoleError']),
      permissionOptions: function(){
        if(!this.permissions)
          return [];

        const permissions = this.permissions.filter(({moduleName}) => moduleName != "configurations");
        const transactionMaker = this.checkedPermissions.find(({genericName}) => genericName === 'transaction-maker');
        const transactionChecker = this.checkedPermissions.find(({genericName}) => genericName === 'transaction-checker');

        if(transactionMaker)
          return permissions.filter(({genericName}) => genericName !== 'transaction-checker');
        else if(transactionChecker)
          return permissions.filter(({genericName}) => genericName !== 'transaction-maker');
        else
          return permissions;
      }
    },
    watch: {
      roleBeingEdited: function(role){
        if(!role || !role.rolePermissions)
          return;

        this.checkedPermissions = role.rolePermissions.permissions;
      }
    },
    methods: {
      close(){
        this.$router.replace('/userAccess/roles/');
      },
      updateRolePermissions(e){
        if(e && e.preventDefault)
          e.preventDefault();

        if(!this.checkedPermissions.length || !this.roleBeingEdited || !this.roleBeingEdited.rolePermissions){
          this.formHasError = true;
          return;
        }
        const originalPermissions = this.roleBeingEdited.rolePermissions.permissions;
        const originalPermissionsIds = originalPermissions.map(p => p._id);
        const checkedPermissionsIds = this.checkedPermissions.map(p => p._id);
        const addedPermissions = this.checkedPermissions.filter(p => originalPermissionsIds.indexOf(p._id) === -1);
        const removedPermissions = originalPermissions.filter(p => checkedPermissionsIds.indexOf(p._id) === -1);

        const data = {
          role: this.roleBeingEdited._id,
          permissions: {
            added: addedPermissions.map(p => p._id),
            removed: removedPermissions.map(p => p._id)
          }
        };

        this.$store.dispatch('editRolePermissions', {data, addedPermissions});
      }
    },
    components: { Multiselect }
  }
</script>
